import React, { Component } from "react";
import { connect } from "react-redux";
import { SubmissionError } from "redux-form";
import { fetchReferrals } from "../../../../actions/dropdowns.actions";
import { createCandidate } from "../../../../actions/user.actions";
import SignUp from "../components/SignUp";

class SignUpContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkboxError: null
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(accountData) {
    if (!accountData.terms) {
      this.setState({
        checkboxError:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
      throw new SubmissionError({
        terms:
          "You must agree to our Terms of Service and Privacy Policy to continue."
      });
    }

    this.setState({ checkboxError: null });
    this.props.createCandidate(accountData);
  }

  componentWillMount() {
    this.props.fetchReferrals();
  }

  render() {
    return (
      <SignUp
        onSubmit={this.handleSubmit}
        referrals={this.props.referrals}
        checkboxError={this.state.checkboxError}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    referrals: state.dropdowns.referrals.data,
    isLoading: state.company.isLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchReferrals: () => dispatch(fetchReferrals()),
    createCandidate: user => dispatch(createCandidate(user))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/signUp/containers/SignUpContainer.js